import React, { memo } from "react";

interface IProps {
  size?: number;
}

const CacheMenuIcon: React.FC<IProps> = memo(({ size = 16 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M7.26562 0.661735C7.73125 0.446088 8.26875 0.446088 8.73438 0.661735L15.5656 3.81829C15.8312 3.94018 16 4.20583 16 4.49961C16 4.79339 15.8312 5.05904 15.5656 5.18093L8.73438 8.33749C8.26875 8.55313 7.73125 8.55313 7.26562 8.33749L0.434375 5.18093C0.16875 5.05591 0 4.79026 0 4.49961C0 4.20896 0.16875 3.94018 0.434375 3.81829L7.26562 0.661735ZM13.9031 7.04986L15.5656 7.81868C15.8312 7.94057 16 8.20622 16 8.5C16 8.79378 15.8312 9.05943 15.5656 9.18132L8.73438 12.3379C8.26875 12.5535 7.73125 12.5535 7.26562 12.3379L0.434375 9.18132C0.16875 9.0563 0 8.79065 0 8.5C0 8.20935 0.16875 7.94057 0.434375 7.81868L2.09687 7.04986L6.84688 9.24382C7.20842 9.4106 7.60184 9.49697 8 9.49697C8.39816 9.49697 8.79158 9.4106 9.15312 9.24382L13.9031 7.04986ZM9.15312 13.2442L13.9031 11.0503L15.5656 11.8191C15.8312 11.941 16 12.2066 16 12.5004C16 12.7942 15.8312 13.0598 15.5656 13.1817L8.73438 16.3383C8.26875 16.5539 7.73125 16.5539 7.26562 16.3383L0.434375 13.1817C0.16875 13.0567 0 12.791 0 12.5004C0 12.2097 0.16875 11.941 0.434375 11.8191L2.09687 11.0503L6.84688 13.2442C7.20842 13.411 7.60184 13.4974 8 13.4974C8.39816 13.4974 8.79158 13.411 9.15312 13.2442Z"
        fill="currentColor"
      />
    </svg>
  );
});

export { CacheMenuIcon };
